export const clickButtonById = (buttonId: string) => {
  const button = document.querySelector(buttonId) as HTMLButtonElement;
  if (button) button.click();
};
